import { useEffect, useMemo, useState } from "react";

export default function AnimatedCounter({
  value,
  duration = 1200,
  suffix = "",
  prefix = ""
}) {
  const [current, setCurrent] = useState(0);
  const end = useMemo(() => Number(value) || 0, [value]);

  useEffect(() => {
    let start = 0;
    const startTs = performance.now();

    const tick = (ts) => {
      const progress = Math.min((ts - startTs) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      start = Math.round(end * eased);
      setCurrent(start);
      if (progress < 1) requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  }, [end, duration]);

  return (
    <span>
      {prefix}
      {current}
      {suffix}
    </span>
  );
}
